import React, { useState } from 'react';

// Spring Imports
import { useTransition, animated } from 'react-spring';

// Local Imports
import AboutMe from '../components/website/home/AboutMe';
import Counseling from '../components/website/home/Counseling';
import Counters from '../components/website/home/Counters';
import CtaContainer from '../components/website/home/CtaContainer';
import FooterSection from '../components/layout/FooterSection.js';
import OurVoiceTone from '../components/website/home/OurVoiceTone';
import Training from '../components/website/home/Training';
import Welcome from '../components/website/home/Welcome';

const HomeLayout = () => {
	// Component useState
	const [toggle] = useState(false);

	// Component Transitions
	const transition = useTransition(toggle, null, {
		from: { transform: 'translate3d(-558px,0px,0)' },
		enter: { transform: 'translate3d(0,0px,0)' },
	});

	return (
		<div onLoad={window.scrollTo(0, 0)}>
			{transition.map(({ item, key, props }) => (
				<animated.div key={key} style={props}>
					<Welcome />
					<Training />
					<Counseling />
					<CtaContainer />
					<AboutMe />
					<OurVoiceTone />
					<Counters />
					<FooterSection />
				</animated.div>
			))}
		</div>
	);
};

export default HomeLayout;
